export default {
  props: {
    /**
      * Show or hide component
      */
    visible: {type: Boolean, default: true}
  }
};
